import 'lazysizes';
import initAOS from './initAOS';
import initModal from './initModal';
import initSmoothScroll from './initSmoothScroll';
import initSubscription from './initSubscription';

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expand = 1000;
lazySizesConfig.expFactor = 4;

document.addEventListener('DOMContentLoaded', (e) => {
  initAOS();
  initModal();
  initSubscription();

  const anchors = document.querySelectorAll("a[href^='#']");
  anchors.forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      e.preventDefault();
      const fullHref = anchor.href;
      const href = anchor.getAttribute('href');
      const destination = document.querySelector(href);

      const url = new URL(fullHref);
      history.pushState({}, '', url);

      if (!destination) return;
      initSmoothScroll(destination);
    });
  });

  const shadow = document.querySelector('[data-content-shadow]');
  const burgers = document.querySelectorAll('[data-burger]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const languageTrigger = document.querySelectorAll('[data-choose-language]');
  const languageMenu = document.querySelector('[data-languages-menu]');
  const desktopMenuTriggers = document.querySelectorAll('[data-desktop-nav-trigger]');
  const mobileMenuTriggers = document.querySelectorAll('[data-nav-dropdown-item]');

  ['mouseenter', 'click'].forEach((item) => {
    desktopMenuTriggers.forEach((trigger) => {
      trigger.addEventListener(item, (e) => openHeaderDropdown(trigger));
    });
  });

  desktopMenuTriggers.forEach((trigger) => {
    trigger.addEventListener('mouseleave', (e) => closeHeaderDropdown(trigger));
  });

  mobileMenuTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => toggleMobileDropdown(trigger));
  });

  const clearHandlers = () => {
    shadow.classList.remove('is_visible');
    mobileMenu.classList.remove('is_opened', 'is_overlayed');
    languageMenu.classList.remove('is_visible');

    desktopMenuTriggers.forEach((trigger) => closeHeaderDropdown(trigger));
    enableScroll();
  };

  const openLanguageMenu = () => {
    mobileMenu.classList.add('is_overlayed');

    languageMenu.classList.add('is_visible');
    shadow.classList.add('is_visible');
    disableScroll();
  };

  const toggleMobileMenu = () => {
    if (mobileMenu.classList.contains('is_opened')) {
      clearHandlers();
      return;
    }

    mobileMenu.classList.add('is_opened');
    shadow.classList.add('is_visible');
    disableScroll();
  };

  shadow.addEventListener('click', () => {
    if (mobileMenu.classList.contains('is_opened') && languageMenu.classList.contains('is_visible')) {
      mobileMenu.classList.remove('is_overlayed');
      languageMenu.classList.remove('is_visible');
      return;
    }

    clearHandlers();
  });

  languageTrigger.forEach((trigger) => {
    trigger.addEventListener('click', openLanguageMenu);
  });

  burgers.forEach((burger) => {
    burger.addEventListener('click', toggleMobileMenu);
  });

  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      clearHandlers();
    }
  });

  // Check if cookies disabled
  if (!navigator.cookieEnabled) {
    const loader = document.getElementById('page_overlay');
    loader.style.display = 'none';
  }

  // ==> Hide directadvert images
  // setTimeout(() => $('img[src*="directadvert"]').each((i, item) => $(item).hide()), 1000);

  const assetProfitItems = document.querySelectorAll('[data-asset-profit]');
  assetProfitItems.forEach((item) => paintAsset(item));
});

const openHeaderDropdown = (trigger) => {
  const index = trigger.querySelector('[data-nav-category-index]').dataset.navCategoryIndex;
  const menu = trigger.querySelector(`[data-nav-category-list-index='${index}']`);
  trigger.classList.add('is_active');
  menu.classList.add('is_active');
};

const closeHeaderDropdown = (trigger) => {
  const index = trigger.querySelector('[data-nav-category-index]').dataset.navCategoryIndex;
  const menu = trigger.querySelector(`[data-nav-category-list-index='${index}']`);
  trigger.classList.remove('is_active');
  menu.classList.remove('is_active');
};

const toggleMobileDropdown = (trigger) => {
  const menu = trigger.nextElementSibling;
  trigger.parentElement.classList.toggle('is_opened');

  // $(menu).slideToggle();
  if (menu.style.display === 'block') {
    menu.style.display = 'none';
  } else {
    menu.style.display = 'block';
  }
};

// ============== GLOBAL STUFF ============== //

// ==> Quotes
const WEBSOCKET_TORNADO_URL = 'wss://ws.grandcapital.net/';

const SYMBOL_LIST = {
  Forex: ['AUDUSD', 'EURUSD', 'GBPUSD', 'NZDUSD', 'USDCAD', 'USDCHF', 'USDJPY', 'GBPJPY', 'EURJPY', 'NZDCAD', 'EURGBP', 'AUDCAD', 'AUDNZD', 'EURCHF'],
  Stocks: ['#AMZN', '#AAPL', '#BABA', '#FB', '#GOOGL', '#IBM', '#MSFT', '#NVDA', '#PEPSI', '#TESLA', '#AA', '#BA', '#DIS', '#PFE'],
  Indices: ['CAC40', 'DAX30', 'ESTOXX50', 'IBEX35', 'FTSE100', 'SP500', 'DJI30', 'NQ100', 'JP225', 'SMI20', 'HSI50', 'ASX200'],
  Metals: ['XAUUSDe', 'XAGUSDe', 'XAUEURe', 'XAGEURe', 'XPDUSDe', 'XPTUSDe', 'CUCUSDe'],
  Energy: ['WTI', 'BRN', 'NG'],
  Crypto: ['BTCUSD', 'ETHUSD', 'BCHUSD', 'LTCUSD', 'TRXUSD', 'XMRUSD', 'BNBUSD', 'NEOUSD', 'XLMUSD', 'DSHUSD', 'ZECUSD', 'BATUSD', 'EOSUSD', 'OMGUSD'],
};

// ==> Media queries in js
// const mobileMax = (width) => window.matchMedia(`(max-width: ${width}px)`).matches;
// const desktopMin = (width) => window.matchMedia(`(min-width: ${width}px)`).matches;
// ==> End of Media queries in js

// ==> Disable/Enable scroll script
const disableScroll = () => document.body.classList.add('no_scroll');
const enableScroll = () => document.body.classList.remove('no_scroll');

const isNegative = (str) => str.textContent.startsWith('-');
const isPositive = (str) => str.textContent.startsWith('+');

const paintAsset = (asset) => {
  switch (true) {
    case isPositive(asset):
      return asset.classList.add('profit--up');
    case isNegative(asset):
      return asset.classList.add('profit--down');
    default:
      return;
  }
};

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
